

























import { Component, Emit, Vue } from 'vue-property-decorator'

@Component
export default class CannotUseTheTel extends Vue {
  @Emit()
  retry() {
    // nothing to do
  }
}
